import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  Box, 
  Typography, 
  Button,
  alpha 
} from '@mui/material';
import { Celebration as CelebrationIcon } from '@mui/icons-material';
import { useSystemConfig } from '../hooks/useSystemConfig';

interface FreeCreditsWelcomeBannerProps {
  open: boolean;
  onClose: () => void;
}

export const FreeCreditsWelcomeBanner: React.FC<FreeCreditsWelcomeBannerProps> = ({ open, onClose }) => {
  const { signup_credits: signupCredits } = useSystemConfig();
  return (
    <Dialog 
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
        }
      }}
    >
      <Box
        sx={{
          background: 'linear-gradient(135deg, #2e7d32 0%, #388e3c 100%)',
          color: 'white',
          py: 4,
          px: 3,
          textAlign: 'center',
        }}
      >
        <CelebrationIcon sx={{ fontSize: 80, mb: 2, animation: 'bounce 1s ease-in-out infinite' }} />
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
          Welcome! 🎉
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 600, opacity: 0.95 }}>
          +{signupCredits.toLocaleString()} AI Credits Added
        </Typography>
      </Box>
      
      <DialogContent sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
            Your Free Trial Has Started!
          </Typography>
          <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            You've been granted <strong>{signupCredits.toLocaleString()} free AI credits</strong> to explore our platform. 
            Start building AI-powered features, create chatbots, or process data in batches!
          </Typography>
          
          <Box 
            sx={{ 
              bgcolor: alpha('#2e7d32', 0.08), 
              borderRadius: 2, 
              p: 2, 
              mb: 3,
              border: '2px solid',
              borderColor: alpha('#2e7d32', 0.2)
            }}
          >
            <Typography variant="body2" color="textSecondary" gutterBottom>
              ✓ No credit card required
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              ✓ Full access to all AI models
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              ✓ Build unlimited AI functions
            </Typography>
            <Typography variant="body2" color="textSecondary">
              ✓ Upgrade anytime for more credits
            </Typography>
          </Box>

          <Button
            variant="contained"
            size="large"
            onClick={onClose}
            sx={{
              px: 6,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 600,
              background: 'linear-gradient(135deg, #2e7d32 0%, #388e3c 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)',
              }
            }}
          >
            Let's Get Started!
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

